document.addEventListener('turbo:load', function() {
  $('body').on('change', '.identity-document-proof__input', function() {
    const url = URL.createObjectURL($(this).prop('files')[0]);
    $('.identity-document-proof__file').attr('src', url);
  });
});
